export const LOGIN_CONSTANT = {
  NAME: {
    USERNAME: "username",
    PASSWORD: "password",
  },
  LABEL: {
    ID: "ID",
    PASSWORD: "パスワード",
  },
  TITLE: {
    LOGIN: "ログイン",
    DESCRIPTION: "ログインするには、以下の情報を入力してください。",
  },
  MESSAGE: {
    // MSG-PC001-E01 — auth fail (ID/PW sai)
    WRONG_INFO:
      "IDまたはパスワードが正しくありません。もう一度お試しください。",
    // MSG-PC001-E02 — network / server unreachable
    NETWORK_ERROR:
      "サーバーに接続できません。ネットワーク接続を確認してから再度お試しください。",
  },
  PLACEHOLDER: {
    INPUT: "入力",
  },
  // Static branding theo Screen Spec VAMS_PC_001 v1.3 (画面項目一覧: Logo / Version Label)
  LOGO: "VAMS 資産棚卸管理システム",
  VERSION: "Version 1.0.0",
};
// ID: half-width alphanumeric only, max 50 (Screen Spec [1]).
export const REGEX_ID = /^[a-zA-Z0-9]{1,50}$/;
// Password: half-width alphanumeric + symbols (printable ASCII, no space), max 100 (Screen Spec [2]).
export const REGEX_PASSWORD = /^[\x21-\x7e]{1,100}$/;
